import React from "react"
import PropTypes from "prop-types"
import OpenOrderNameModal from "../../containers/shop/open-order-name-modal"
import OpenOrdersListModal from "../../containers/shop/open-orders-list-modal"

class OpenOrdersButton extends React.Component {

  render() {
    const isVisible = this.props.itemsCount > 0 && !this.props.currentId
    return (
      <div className="open-orders-button" ref={e => this.domElement = e}>
        <button onClick={this.props.onClick}
          style={{visibility: isVisible ? "visible" : "hidden"}}>
          Open Tabs&nbsp;
          <i>({this.props.itemsCount} pending)</i>
        </button>
        <OpenOrderNameModal targetRef={this.domElement} />
        <OpenOrdersListModal />
      </div>
    )
  }
}

OpenOrdersButton.propTypes = {
  onClick: PropTypes.func
}

export default OpenOrdersButton
